import { Box, Button, Typography } from '@mui/material';
import React, { useContext } from 'react'
import { AiOutlineColumnHeight } from 'react-icons/ai';
import Bid from '../../components/Quote/Bid';
import Ask from '../../components/Quote/Ask';
import { ThemeContext } from '../../../context/ThemeContext';
import DailyChange from '../../../components/global/BidAsk/DailyChange';
import PercentageChange from '../../../components/global/BidAsk/PercentageChange';
import SpreadValue from '../../../components/global/BidAsk/SpreadValue';
import Low from '../../../components/global/BidAsk/Low';
import High from '../../../components/global/BidAsk/High';
import AmountInput from '../../components/Quote/AmountInput';
import { useTranslation } from 'react-i18next';

export default function AdvanceOneClickView({ symbol, handleTrade }) {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()

    return (
        <>
            <Box sx={{ p: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Ask symbolId={symbol?.id} />
                        <Button variant='outlined' size='small' fullWidth sx={{ px: 3 }} color='error' onClick={e => handleTrade(-1, symbol?.id)}>{t('sell')}</Button>
                        <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>H: <High symbolId={symbol?.id} /></small></Typography>
                    </Box>
                </Box>
                <Box sx={{ backgroundColor: darkMode ? "#151924" : 'var(--white)', textAlign: "center", display: "flex", flexDirection: "column", alignItems: 'center' }}>
                    <Typography variant="body1" fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : 'var(--black)', margin: 0 }}>{symbol?.name}</Typography>
                    <AmountInput symbolId={symbol?.id} />
                    <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                        {/* <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>08:27:20 </Typography> */}
                        <Typography fontSize={12} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><PercentageChange symbolId={symbol?.id} /></Typography>
                        <AiOutlineColumnHeight fontSize={13} style={{ margin: "0 0 0 3px", color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} />
                        <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)', fontWeight: 600 }}><SpreadValue symbolId={symbol?.id} /></Typography>
                    </Box>
                </Box>
                <Box>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Bid symbolId={symbol?.id} />
                        <Button variant='outlined' size='small' fullWidth sx={{ px: 3 }} color='success' onClick={e => handleTrade(1, symbol?.id)}>{t('buy')}</Button>
                        <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>L:<Low symbolId={symbol?.id} /></small></Typography>
                    </Box>
                </Box>
            </Box>

        </>
    )
}
